import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=70601af1&scoped=true&"
import script from "./OrderManagement.vue?vue&type=script&lang=ts&"
export * from "./OrderManagement.vue?vue&type=script&lang=ts&"
import style0 from "./OrderManagement.vue?vue&type=style&index=0&id=70601af1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70601af1",
  null
  
)

export default component.exports